var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 295,
    fill: "#fff",
    opacity: 0.1,
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 295C66.167 295 0 228.833 0 147.5S66.167 0 147.5 0 295 66.167 295 147.5c-.015 81.333-66.182 147.5-147.5 147.5zm0-290.043C68.902 4.957 4.957 68.902 4.957 147.5S68.902 290.043 147.5 290.043 290.043 226.098 290.043 147.5 226.098 4.957 147.5 4.957zm-.001 273.947c-72.445 0-131.386-58.941-131.386-131.385S75.054 16.133 147.499 16.133s131.386 58.941 131.386 131.386c-.016 72.444-58.957 131.385-131.386 131.385zm0-257.814c-69.71 0-126.429 56.719-126.429 126.429s56.719 126.428 126.429 126.428 126.429-56.719 126.429-126.428S217.209 21.09 147.499 21.09zm.001 241.688c-63.556 0-115.271-51.715-115.271-115.271S83.944 32.235 147.5 32.235 262.772 83.95 262.772 147.507c-.016 63.556-51.715 115.271-115.272 115.271zm0-225.586c-60.836 0-110.314 49.493-110.314 110.315 0 60.837 49.493 110.314 110.314 110.314s110.315-49.493 110.315-110.314S208.322 37.192 147.5 37.192z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/pattern-1.44376edec310976ea08bce0f5d9ad362.svg";
export { ForwardRef as ReactComponent };